import { useAsyncData } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useUrlParams } from '~/scopes/product/composables/useUrlParams'
import { getOptionalEndpointTimeoutOptions } from '~/scopes/product/utils/optionalEndpointTimeout'

export function useFetchReviewsSummary() {
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    `pp-review-summary-${productId}`,
    () =>
      $httpFetch('/reviews/products/:uuid/reviews-summary', {
        pathParams: { uuid: productId },
      }),
    {
      ...getOptionalEndpointTimeoutOptions(),
      dedupe: 'defer',
    },
  )
}
